/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-empty */
import { JsonApiLink, JsonApiRecurso, JsonApiRelacion } from './json-api.types';
// Imports lodash: mediante el plugin babel-transform-imports se incluyen sólo funciones usadas para reducir bundle size
import { assign, find, forEach, isArray, isEqual, unset } from 'lodash';

/**
 * Clase base para models: formato de recursos, basado en formato JSON-API.
 * Incluye métodos para setear atributos, links y recursos relacionados de la API
 */
export class ApiModel {

  id: any;
  api_type!: string;

  // Los atributos son seteados mediante el constructor/setDataFromStorage, o en setDataFromApi
  //    y quedan como atributos del objeto

  // Las relaciones con otros recursos son seteados mediante setRelationships
  //    y quedan como atributos del objeto

  // Links a endpoints API de recursos relacionado al model
  //    El link al propio recurso es guardado en api_links.self
  api_links?: { [name: string]: JsonApiLink };

  /**
   * Definición de nombres de atributos a enviar en request a API (POST o PATCH) según el api_type del ApiModel
   *  Esto permite enviar a API sólo los atributos del objeto que espera cada endpoint
   *  Utilizado en nuevas features a partir de v8.4.0
   *
   *  Es un mapeo api_type -> [ <keys de atributos a enviar en request> ]
   *
   *  ToDo soportar funcion como alternativa a arreglo de string, que directamente retorne los atributos según api_type.
   *    Esto sería útil para los casos más complejos, donde los atributos del request se determinan de forma condicional
   *    (ver por ejemplo models Gasto.ts o CobranzaNoIdentificada.ts)
   */
  api_types_keys_atributos_request!: { [api_type: string]: string[] } | Function;

  /**
   * Definición de nombres de relationships a enviar en request a API (POST o PATCH) según el api_type del ApiModel
   *  Esto permite enviar a API sólo las relaciones del objeto que espera cada endpoint
   *
   *  Es un mapeo api_type -> [ <keys de relationship a enviar en request> ]
   */
  api_types_keys_relaciones_request!: { [api_type: string]: string[] };

  /**
   * Atributos del ApiModel para POST / PATCH a la API
   *  (redefinir en models que se usen para requests a la API: creación o edición)
   *  Define qué attributes se incluyen en el request body.
   * Este atributo es leido para generar los recursos enviados para ser creados o actualizados
   *
   * @deprecated - Utilizar api_types_keys_atributos_request, es más simple. Se utiliza en features anteriores a v8.4.0
   *                Requiere modificaciones en endpoints, usando distintos api_types para un mismo recurso
   */
  get atributos_request(): { [key_atributo: string]: any } {
	  return {};
  }

  /**
   * Relaciones del ApiModel para POST / PATCH a la API
   *  (redefinir en models que se usen para requests a la API: creación o edición)
   *  Define qué relationships se incluyen en el request body.
   * Este atributo es leido para generar los recursos enviados para ser creados o actualizados
   *
   * @deprecated - Utilizar api_types_keys_relaciones_request, es más simple.
   */
  get relaciones_request(): { [relacion: string]: ApiModel | ApiModel[] } {
	  return {};
  }

  /**
   * Retorna los atributos del objeto a enviar en un request
   *  Si define mapeo api_types_keys_atributos_request (a partir de v8.4.0) con el api_type actual,
   *  utiliza los atributos de las keys definidas.
   *  Sino, si utiliza función api_types_keys_atributos_request utiliza los atributos devueltos por la misma.
   *  Si no, utiliza getter atributos_request
   */
  getAtributosRequest(): { [key_atributo: string]: any } {
	  if (this.api_types_keys_atributos_request) {
	    let atributos = {};
	    if (typeof this.api_types_keys_atributos_request === 'function') {
	      atributos = this.api_types_keys_atributos_request();
	      if (atributos) {
	        return atributos;
	      }
	    }
	    else if (this.api_types_keys_atributos_request[this.api_type]) {
	      for (let key_atributo of this.api_types_keys_atributos_request[this.api_type]) {
	        if (this[key_atributo] !== undefined) {
	          atributos[key_atributo] = this[key_atributo];
	        }
	      }
	      return atributos;
	    }
	  }
	  return this.atributos_request;
  }

  /**
   * Retorna los atributos del objetos que hayan sido modificados, en comparación con el objeto recibido como parámetro
   *
   * Esto es usado para obtener los atributos a utilizar en un request PATCH (edición) a la API,
   *  en donde sólo se quieran enviar los atributos que cambiaron
   *
   * @param objeto_original
   *
   * @return Object
   */
  getAtributosModificados(objeto_original: ApiModel): { [key_atributo: string]: any } {
	  let atributos_modificados = {};
	  if (this.api_types_keys_atributos_request) {
	    if (typeof this.api_types_keys_atributos_request === 'function'
				&& typeof objeto_original.api_types_keys_atributos_request === 'function') {
	      let atributos_originales = objeto_original.api_types_keys_atributos_request();
	      for (let key_atributo in atributos_originales) {
	        if (atributos_originales.hasOwnProperty(key_atributo)) {
	          if (this[key_atributo] !== undefined && !isEqual(this[key_atributo], atributos_originales[key_atributo])) {
	            atributos_modificados[key_atributo] = this[key_atributo];
	          }
	        }
	      }
	    }
	    else if (this.api_types_keys_atributos_request[this.api_type]) {
	      // Si se definen los nombres de atributos a enviar en request para el api_type del model, recorre esos
	      for (let key_atributo of this.api_types_keys_atributos_request[this.api_type]) {
	        if (this[key_atributo] !== undefined && !isEqual(this[key_atributo], objeto_original[key_atributo])) {
	          atributos_modificados[key_atributo] = this[key_atributo];
	        }
	      }
	    }
	  }
	  else {
	    // Si no, compara los atributos definidos en atributos_request de ambos objetos (deprecated)
	    const atributos_actuales = this.atributos_request;
	    const atributos_originales = objeto_original.atributos_request;

	    for (let key in atributos_actuales) {
	      if (atributos_actuales[key] !== atributos_originales[key]) {
	        atributos_modificados[key] = atributos_actuales[key];
	      }
	    }
	  }
	  return atributos_modificados;
  }

  /**
   * Retorna las relaciones del objeto a enviar en un request
   *  Si define mapeo api_types_keys_relaciones_request (a partir de v8.4.0) con el api_type actual,
   *  utiliza los atributos de las keys definidas.
   *  Si no, utiliza getter atributos_request
   */
  getRelacionesRequest(): { [key_relacion: string]: any } {
	  if (this.api_types_keys_relaciones_request && this.api_types_keys_relaciones_request[this.api_type]) {
	    let relaciones = {};
	    for (let key_relacion of this.api_types_keys_relaciones_request[this.api_type]) {
	      if (this[key_relacion] !== undefined) {
	        relaciones[key_relacion] = this[key_relacion];
	      }
	    }
	    return relaciones;
	  }
	  else {
	    return this.relaciones_request;
	  }
  }

  constructor(data?: any) {
	  assign(this, data);
  }

  /**
   * Setea atributos del model a partir de data guardado en storage.
   *     En storage se guarda el objecto entero, por lo que es igual al constructor
   * Los models que se guarden en storage de una forma distinta, deben redefinir este método
   */
  setDataFromStorage(data: any) {
	  // Quito timestamp guardado en storage, usado para controles
	  unset(data, 'storage_timestamp');
	  assign(this, data);
  }

  /**
   * Setea atributos del model a partir de data obtenido de la API, seteando links y creando recursos relacionados
   *  Los models que hagan un trato especial con los atributos, deben redefinir este método.
   *
   * El parámetro data debe ser un "resource object" que cumple la especificación JSON-API
   *    Ver http://jsonapi.org/format/#document-resource-objects
   *
   * El parámetro relaciones_included, permite indicar el arreglo included obtenido en la API
   *   para buscar si se encuentra datos de los recursos relacionados
   * El parámetro self_link, permite setear el link al mismo recurso en el arreglo api_links
   */
  setDataFromApi(data: JsonApiRecurso, relaciones_included?: JsonApiRecurso[], self_link?: JsonApiLink) {
	  this.id = data.id;
	  this.api_type = data.type;

	  if (data.attributes) {
	    assign(this, data.attributes); // Copia atributos obtenidos al ApiModel
	  }
	  if (data.relationships) {
	    this.setRelationships(data.relationships, relaciones_included || []);
	  }
	  if (data.links) { // Links contenidos dentro de la data del recurso
	    this.setApiLinks(data.links);
	  }
	  if (self_link) {
	    this.setSelfApiLink(self_link);
	  }
  }

  protected setRelationships(relationships: { [name: string]: JsonApiRelacion }, included: JsonApiRecurso[]) {
	  forEach(relationships, (relacion: JsonApiRelacion, rel_name: string) => {
	    let recurso_rel = relacion.data;
	    if (isArray(recurso_rel)) {
	      this[rel_name] = [];
	      for (let recurso of (<Array<JsonApiRecurso>> recurso_rel)) {
	        this[rel_name].push(this.crearRecursoRelacionado(recurso, rel_name, included));
	      }
	    }
	    else {
	      this[rel_name] = this.crearRecursoRelacionado(<JsonApiRecurso>recurso_rel, rel_name, included);
	    }
	  });
  }

  protected crearRecursoRelacionado(data_recurso: JsonApiRecurso, nombre_relacion: string, included: JsonApiRecurso[]): ApiModel {
	  let recurso = new ApiModel();
	  recurso.setDataFromApi(data_recurso);

	  if (nombre_relacion) {
	  }
	  if (included) {
	    // Busca si el recurso está en el arreglo included para asignarle los atributos
	    let data_included = find(included,
	      (include: any) => (include.type === data_recurso.type && include.id === data_recurso.id)
	    );
	    // console.log('Data included',data_included);
	    if (data_included && data_included.attributes) {
	      assign(recurso, data_included.attributes);
	    }
	  }
	  // console.log('crearRecursoRelacionado',data_recurso,included,recurso);
	  return recurso;
  }

  protected setApiLinks(links: { [name: string]: JsonApiLink }) {
	  if (!this.api_links) {
	    // Inicializo
	    this.api_links = {};
	  }
	  for (let link_name in links) {
	    let link_data = links[link_name];
	    if (!link_data.href) { // || link_data.method === 'web') {
	      // Si no tiene definido href no guarda el link - FIX: se guardan links web
	      continue;
	    }
	    let link: JsonApiLink = {
	      href: link_data.href
	    };
	    // Agrego método y meta si tiene
	    if (link_data.method) {
	      link.method = link_data.method;
	    }
	    if (link_data.meta) {
	      link.meta = link_data.meta;
	    }
	    if (link_data.url_placeholders) {
	      link.url_placeholders = link_data.url_placeholders;
	    }
	    // Agrego a arreglo api_links
	    this.api_links[link_name] = link;
	  }
  }

  /**
   * Obtiene link a recurso relacionado
   * @param name Nombre link
   */
  getApiLink(name: string): JsonApiLink | null {
	  if (!this.api_links || !this.hasApiLink(name)) {
	    return null;
	  }
	  return this.api_links[name];
  }

  /**
   * Obtiene url del link de recurso indicado
   *
   * @param name Nombre link
   */
  getApiLinkHref(name: string): string {
	  if (!this.api_links || !this.hasApiLink(name)) {
	    return '';
	  }
	  return this.api_links[name].href;
  }

  hasApiLink(name: string): boolean {
	  return !!this.api_links && this.api_links.hasOwnProperty(name);
  }

  /**
   * Setea link al mismo recurso
   * @param link
   */
  setSelfApiLink(link: JsonApiLink) {
	  if (!this.api_links) {
	    this.api_links = {};
	  }
	  this.api_links.self = link;
  }

  getSelfApiLink(): JsonApiLink | null {
	  return this.getApiLink('self');
  }

  getSelfApiLinkHref(): string {
	  return this.getApiLinkHref('self');
  }

}

// Atributo tipo archivo
export interface Archivo {
  nombre_original: string,
  links: {
    descarga: JsonApiLink
  }
}